import {writable, get} from 'svelte/store';
import {format} from 'date-fns';
import {el} from 'date-fns/locale';

let USER = {};

export const getUser = () => USER;
export const venues$ = writable(null);
export const billables$ = writable(null);
export const terms$ = writable(null);
export const extraData$ = writable(null);
export const serviceCategories$ = writable([]);
export const contacts$ = writable([]);
export const eventTypes$ = writable([]);
export const isNumeric = num => /^-?[0-9]+(?:\.[0-9]+)?$/.test(num + '');


export const getCookie = function (name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
};

export const round = (num, points = 2) => {
    const exp = 10 ** points;
    return Math.round((num + Number.EPSILON) * exp) / exp;
};

export const findItem = (id, collection, col = 'id') => collection.find(p => p[col] == id);
export const copyObj = o => JSON.parse(JSON.stringify(o));



export const YMD = dt => format(dt, 'yyyy-MM-dd');
export const DMY = dt => {
    if (Object.prototype.toString.call(dt) !== '[object Date]') {
        dt = new Date(dt);
    }
    return format(dt, 'dd/MM/yyyy');
};
export const dDMY = dt => {
    if (Object.prototype.toString.call(dt) !== '[object Date]') {
        dt = new Date(dt);
    }
    return format(dt, 'EEE dd/MM/yyyy', {
        locale: el
    });
};
export const dDMYhm = dt => {
    if (Object.prototype.toString.call(dt) !== '[object Date]') {
        dt = new Date(dt);
    }
    return format(dt, 'EEE dd/MM/yyyy hh:mm', {
        locale: el
    });
};
export const dateToYYMM = (dt = null) => {
    if (Object.prototype.toString.call(dt) !== '[object Date]') {
        dt = dt===null ? new Date() : new Date(dt);
    }
    return format(dt, 'yyyy-MM');
};
//-- stop here --

export const nameOfMonths = [...Array(12).keys()].map(i => el.localize.month(i));
export const nameOfDays = () => [...Array(7).keys()].map(i => el.localize.day(i, {width: 'abbreviated'}));


const createMapFromArray = (array, column = 'id') => {
    const m = new Map();
    array.map(i => m.set(i[column], i));
    return m;
};

export const makeSearchable = text => text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();

export const createContactSearchData = c => {
    const string = `${c.first_name}|${c.last_name}|${c.mobile}|${c.phone}|${c.email}`;
    c.fullname = `${c.first_name} ${c.last_name}`;
    c.__search = makeSearchable(string);
    return c;
};

export const initApp = async () => {
    const key = getCookie('gk_api_key');
    if (!key) {
        USER = null;
        return false;
    }
    API.key = key;

    const result = await API.get('whoami');

    if (result.error === false) {
        const data = result.data;
        USER = data.user;
        venues$.set(data.venues);
        eventTypes$.set(data.eventTypes);
        serviceCategories$.set(data.services);
        contacts$.set(data.contacts.map(createContactSearchData));
        extraData$.set(data.extraData);
        billables$.set(data.billables);
        terms$.set(data.terms);
        return true;
    }

    console.error(result.message);
    return false;
};


export const API = {
    key: '',
    getHeaders: () => {
        return {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + API.key,

        };
    },
    get: async (url) => {
        const res = await fetch(`/api/1.0/${url}`, {
            method: 'GET',
            headers: API.getHeaders()
        });

        return await res.json();
    },

    post: async (url, data) => {
        const res = await fetch(`/api/1.0/${url}`, {
            method: 'POST',
            headers: API.getHeaders(),
            body: JSON.stringify(data),
            credentials: 'omit'
        });

        return await res.json();
    },

    patch: async (url, data) => {
        const res = await fetch(`/api/1.0/${url}`, {
            method: 'PATCH',
            headers: API.getHeaders(),
            body: JSON.stringify(data)
        });

        return await res.json();
    },

    delete: async (url) => {
        const res = await fetch(`/api/1.0/${url}`, {
            method: 'DELETE',
            headers: API.getHeaders()
        });

        return await res.json();
    }
};


export const EVENT_STATUS = {
    EVENT_STATUS_NEW: 'new',
    EVENT_STATUS_APPROVED: 'approved',
    EVENT_STATUS_COMPLETED: 'completed',
    EVENT_STATUS_CANCELED: 'canceled',
    EVENT_STATUS_EXPIRED: 'expired',

    texts: {
        new: 'Νεο',
        approved: 'Εγκεκριμμένο',
        completed: 'Ολοκληρώμένο',
        canceled: 'Ακυρωμένο',
        expired: 'Ληγμένο'
    }
};

export const firstNames = ['Άγγελος', 'Άδωνης', 'Άλκηστις', 'Άννα', 'Έφη', 'Ήρα', 'Αγγελική', 'Αθανάσιος', 'Αθανασία', 'Ακίνδυνος', 'Αλέξανδρος', 'Αλίκη', 'Ανάργυρος', 'Αναστασία', 'Ανδρέας', 'Αντώνιος', 'Απόστολος', 'Αργυρώ', 'Βάιος', 'Βανέσα', 'Βαρβάρα', 'Βλάσσης', 'Βρασίδας', 'Γέμελλος', 'Γεωργία', 'Γεώργιος', 'Γρηγόριος', 'Δήμητρα', 'Δήμος', 'Δίδυμος', 'Δηλία', 'Δημήτριος', 'Διαλεχτή', 'Διονυσία', 'Διονύσιος', 'Ειρήνη', 'Ελένη', 'Ερμιόνη', 'Ευάγγελος', 'Ευαγγελία', 'Ευθυμία', 'Ευστάθιος', 'Ευσταθία', 'Ζουμπουλιά', 'Ηλέκτρα', 'Ηλίας', 'Ηρώ', 'Θαρενός', 'Θεοχάρης', 'Θωμάς', 'Θωμαή', 'Ιωάννης', 'Κίρκη', 'Καλυψώ', 'Κανάκης', 'Καρολίνα', 'Κασσάνδρα', 'Κατερίνα', 'Κρέων', 'Κύκκος', 'Κύριλλος', 'Λάζαρος', 'Λάμπρος', 'Λήδα', 'Λαέρτης', 'Λεωνίδας', 'Λουκία', 'Λυδία', 'Λυσίας', 'Μάγια', 'Μαρία', 'Μαργαρίτα', 'Μιλτιάδης', 'Νίκος', 'Νικήτας', 'Νικολέτα', 'Ναυσικά', 'Ολίβια', 'Ορέστης', 'Οφέλλας', 'Οφηλία', 'Πάμελα', 'Παναγιώτης', 'Πτολεμαίος', 'Ρία', 'Ρούλα', 'Σία', 'Σίλβεστρος', 'Σίλβια', 'Σίλβιος', 'Σαμάνθα', 'Σαμπρίνα', 'Σαράντης', 'Σιλβάνα', 'Σιλβέριος', 'Σιλουανός', 'Σοφία', 'Σούλα', 'Σπυρίδων', 'Σπυριδούλα', 'Σταμάτης', 'Σταματίνα', 'Στυλιανός', 'Σωτήριος', 'Τομάζος', 'Τριάδα', 'Τσαμπίκα', 'Τσιτσέκα', 'Υακίνθη', 'Φαίδρα', 'Φαίδρος', 'Φαίδων', 'Φιόνα', 'Φοίβη', 'Φοίβος', 'Χάιδω', 'Χαράλαμπος', 'Χαραλαμπία', 'Χιονία', 'Όλγα'];